// 文章列表 / 详情 — M8 已切真后端（M4 后端 API 已支持，articles 表由 mp_article_list scraper 入库）
// 历史 mock 实现已删除；hook 签名保持不变，调用方零改动
import { useQuery } from '@tanstack/react-query'
import { get } from '@/lib/api'

export interface ArticleListItem {
  id: number
  msgid: string
  title: string
  author: string | null
  publishTime: number
  targetUser: number
  readUser: number
  likeCount: number
  lookingCount: number
  readFinishRate: number
  shareCount: number
  commentCount: number
  favCount: number
  // 2026-06-18 新增 (mp XLS 字段)
  avgReadTime: number      // 平均停留时长(秒)
  audioPlayUser: number    // 听全文（人）
  recommendCount: number   // 推荐 渠道阅读数 (从 source_dist_json 提取)
  coverUrl?: string | null
  isOriginal: boolean
}

export interface ArticleFunnelDatum {
  range: string
  percent: number
  count: number
}

export interface ArticleSourceItem {
  name: string
  value: number
}

export interface ArticleAttrItem {
  name: string
  value: number
}

export interface ArticleHourPoint {
  hour: number
  count: number
}

export interface ArticleDetail extends ArticleListItem {
  favCount: number
  sessionRead: number
  friendShareRead: number
  timelineRead: number
  otherRead: number
  readHourDist: ArticleHourPoint[]
  funnel: ArticleFunnelDatum[]
  sourceDist: ArticleSourceItem[]
  readerAttr: {
    gender: ArticleAttrItem[]
    region: ArticleAttrItem[]
    device: ArticleAttrItem[]
  }
  daysSincePublished: number
  funnelExpireInDays: number
}

interface ArticleListResponse {
  items: ArticleListItem[]
  total: number
  page: number
  pageSize: number
}

export function useArticleList(params: { sort?: 'read' | 'time'; search?: string } = {}) {
  return useQuery({
    queryKey: ['articles', 'list', params],
    queryFn: async () => {
      const qp = new URLSearchParams()
      qp.set('page', '1')
      qp.set('page_size', '50')
      qp.set('sort', params.sort || 'time')
      if (params.search?.trim()) qp.set('search', params.search.trim())
      const resp = await get<ArticleListResponse>(`/articles?${qp.toString()}`)
      return resp.items
    },
  })
}

export function useArticleDetail(id: number | string | undefined) {
  return useQuery({
    enabled: id != null,
    queryKey: ['articles', 'detail', id],
    queryFn: async () => {
      try {
        return await get<ArticleDetail>(`/articles/${id}`)
      } catch (err: unknown) {
        const status = (err as { response?: { status?: number } })?.response?.status
        if (status === 404) return null
        throw err
      }
    },
  })
}
